import React, { useEffect, useState } from "react";
import StickBar from "../components/StickBar";
import Header from "../components/Header";
import { getDocs, collection, query, where } from "firebase/firestore";
import { db } from "../firebase";
import BlogCard from "../components/BlogCard";
import DropdownMultiSelect from "../components/DropdownMultiSelect";
import { CircularProgress } from "@mui/material";
import { SERVER_URL } from "../globalVariables";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchAllBlogs = async () => {
      fetch(`${SERVER_URL}/api/getBlogs`)
        .then((response) => response.json())
        .then((data) => {
          if (data) {
            setBlogs(data?.blogs);
            setCategories(data?.categories);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération des blogs :", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    fetchAllBlogs();
  }, []);

  const handleSortChange = (option) => {
    setSelectedCategories((prev) => {
      if (prev.includes(option)) {
        return prev.filter((s) => s !== option);
      } else {
        return [...prev, option];
      }
    });
  };

  return (
    <div>
      <Header logo={true} />

      <div className="flex">
        <StickBar />

        <div className="w-full lg:pl-[110px] py-8 md:py-14">
          <div className="w-full text-white px-6 md:px-8 lg:px-4 space-y-10 lg:space-y-14">
            <div className="space-y-4">
              <h1>The Blog</h1>

              <div className="bg-white rounded-full h-1 w-full"></div>
            </div>

            {isLoading ? (
              <div className="flex w-full justify-center items-center h-[70vh]">
                <CircularProgress
                  sx={{ color: "#33c7b6" }}
                  style={{ height: 60, width: 60 }}
                />
              </div>
            ) : (
              <div className="space-y-4">
                <div className="flex flex-wrap items-center gap-3 text-white mb-6 justify-end">
                  <DropdownMultiSelect
                    title="Filter by category
"
                    options={categories}
                    selectedOptions={selectedCategories}
                    onChange={handleSortChange}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {blogs
                    .filter(
                      (blog) =>
                        selectedCategories.length === 0 ||
                        selectedCategories.includes(blog.category)
                    )
                    .slice(0, visibleCount)
                    .map((blog) => (
                      <BlogCard key={blog.id} data={blog} />
                    ))}
                </div>

                {blogs.filter(
                  (blog) =>
                    selectedCategories.length === 0 ||
                    selectedCategories.includes(blog.category)
                ).length > visibleCount && (
                  <div className="flex justify-center pt-10">
                    <button
                      onClick={() => setVisibleCount((prev) => prev + 6)}
                      className="bg-white text-black px-6 py-2 rounded-full shadow hover:bg-gray-200 transition"
                    >
                      See more
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
